const NICKNAME_KEY = 'D11_NICKNAME_V1'

export function loadTeamId() {
  try {
    return localStorage.getItem(NICKNAME_KEY) || ''
  } catch (e) {
    return ''
  }
}

export function saveTeamId(nickName) {
  try {
    localStorage.setItem(NICKNAME_KEY, nickName || '')
  } catch (e) {
    // ignore
  }
}

export function clearTeamId() {
  try {
    localStorage.removeItem(NICKNAME_KEY)
  } catch (e) {
    // ignore
  }
}

